class SupernovaTimeline extends window.BAO.CustomElement {
  constructor () {
    super()

    this.bindTicker()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.updateTimeline = this.updateTimeline.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    this.els.pageTrigger.elements.forEach(el => {
      this.listeners.add(el, 'click', this.loadPageContent.bind(this))
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateTimeline)

    this.isTicking = true
  }

  updateTimeline () {
    this.isTicking = false

    const timeline = this.els.timeline.element
    const timelineFill = this.els.timelineFill.element
    const timelineOffset = window.innerWidth < 768 ? 50 : 100

    const containerOffsetTop = window.BAO.utils.getOffsetTop(timeline)
    const elementStartPoint = containerOffsetTop - window.innerHeight * 0.75

    const totalScroll = timeline.clientHeight
    const scrollAmount = this.lastKnownY - elementStartPoint

    if (scrollAmount < 0) {
      timelineFill.style.height = 0
      return
    }

    if (scrollAmount > totalScroll) {
      timelineFill.style.height = '100%'
      return
    }

    this.els.timelineItem.elements.forEach(el => {
      const plus = el.querySelector('.sec-SupernovaTimeline_Plus')
      const top =
        el.offsetTop + plus.offsetTop + plus.clientHeight / 2 + timelineOffset

      el.setAttribute('aria-current', top < scrollAmount)
    })

    timelineFill.style.height = `${scrollAmount}px`
  }

  bindTicker () {
    const ticker = this.els.ticker.element
    const animateWidth = this.tickerItemWidth

    if (animateWidth === 0) return

    while (this.tickerItemWidth < window.innerWidth * 2) {
      ticker.innerHTML = ticker.innerHTML + ticker.innerHTML
    }

    ticker.style.width = `${this.tickerItemWidth}px`
    ticker.style.setProperty('--Animate_Width', `-${animateWidth}px`)
    ticker.classList.add('sec-SupernovaTicker_Inner-animate')
  }

  get tickerItemWidth () {
    const gap = window.innerWidth < 768 ? 60 : 120
    return Array.from(this.els.ticker.element.querySelectorAll('span')).reduce(
      (prev, el) => {
        return prev + el.clientWidth + gap
      },
      0
    )
  }

  loadPageContent (e) {
    e.preventDefault()

    const button = e.target.closest('button')
    const drawer = document.querySelector(
      `site-drawer[key="${button.dataset.drawersTrigger}"]`
    )
    const href = button.dataset.page

    if (!href) return

    fetch(href)
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.art-Article_Article')

        drawer.querySelector('.drw-Drawer_Content').innerHTML = html.innerHTML
      })

    button.removeAttribute('data-page')
  }
}

if (!customElements.get('supernova-timeline')) {
  customElements.define('supernova-timeline', SupernovaTimeline)
}
